// Dependencies that must be import before angular
import 'jquery';
import 'normalize.css';
import 'bootstrap-loader';

// Angular
import angular from 'angular';
import uiRouter from 'angular-ui-router';

// Dependencies that must be import after angular
import 'ui-select';
import 'angular-sanitize';
import 'angular-translate';
import 'angular-translate-loader-url';
import 'angular-translate-loader-partial';
import 'angular-cookies';
import 'angular-toastr';
import 'angular-animate';
import 'angular-promise-extras-extended';

// Our components
import common from './common/common';
import components from './components/components';
import features from './features/features';

import { STATES } from './common/domain/states';

import appConfig from './app.config';
import appRun from './app.run';
import appRunMobile from './app.run.mobile';
import AppComponent from './app.component';

const dependencies = [
  uiRouter,
  'pascalprecht.translate',
  'ngCookies',
  'ngSanitize',
  'ngAnimate',
  'toastr',
  'ngPromiseExtras',
  features,
  common,
  components
];

export {
  angular,
  appConfig,
  appRun,
  appRunMobile,
  AppComponent,
  dependencies,
  STATES
};



// WEBPACK FOOTER //
// ./client/app/app.imports.js